import gql from "graphql-tag";

const gqlQuery = gql`
  query EventUsers($eventId: ID) {
    event(eventId: $eventId) {
      startedByUser {
        name
        username
      }
      finishedByUser {
        name
        username
      }
    }
  }
`;

export default eventId => ({
  query: gqlQuery,
  skip: !eventId,
  variables: { eventId },
});
